import { Stack, Card, CardContent, Typography } from "@mui/material";
import { ViewToggleButtonGroup } from "src/components";
import { useState, useEffect } from "react";
import { useBreakpoints } from "src/hooks";
import { TeamIssuesList, useTeamImplementationSettings } from "src/pages";

interface Props {
  teamSlug: string;
}

const TeamLoopsAgendaStep = (props: Props) => {
  const { isMdUp } = useBreakpoints();
  const [isTableView, setIsTableView] = useState(true);
  const { settings, updateSettings } = useTeamImplementationSettings(props.teamSlug);

  useEffect(() => {
    handleViewToggled(settings.tableView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.teamSlug]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(settings.tableView);
    } else {
      setIsTableView(false);
    }
  }, [isMdUp, props.teamSlug, settings]);

  function handleViewToggled(value: boolean) {
    setIsTableView(value);
    updateSettings({
      tableView: value,
    });
  }

  return (
    <Stack spacing={1}>
      <Card>
        <CardContent>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Stack spacing={0.25}>
              <Typography variant="h5">Loops</Typography>
            </Stack>
            {isMdUp && <ViewToggleButtonGroup isTableView={isTableView} onViewToggled={handleViewToggled} />}
          </Stack>
        </CardContent>
      </Card>
      <TeamIssuesList teamSlug={props.teamSlug} isTableView={isTableView} />
    </Stack>
  );
};

export { TeamLoopsAgendaStep };
